export default __webpack_public_path__ + "static/media/icon-browse.4646ab71.svg";